import React, { useState, useEffect } from 'react';
// import Stories from 'react-insta-stories';

import * as S from './react-stories.styles';
import CrossIcon from './CrossIcon';
import { Header } from './Header';

let Stories;
if (typeof window !== 'undefined') {
  Stories = require('react-insta-stories').default;
}

const customStyle = {
	fontSize: 14,
	bottom: 22
}

interface StoryProps {
  url: string;
  thumb: string;
  type: string;
  caption: string;
}

interface StoryUserProps {
  name: string;
  thumb: string;
}

interface StoryData {
  user: StoryUserProps;
  story: Array<StoryProps>;
  story_label: string;
}

interface StoryViewProps {
  storiesData: StoryData;
  open: boolean;
  onClose: Function
}

export default function ReactStories (props: StoryViewProps) {
    const { storiesData, open, onClose } = props;
    const [openStories, setOpenStories] = useState(open);

    useEffect(() => {
      if (openStories != open) {
        setOpenStories(open)
      }
    }, [open])

    useEffect(() => {
      document.body.style.overflow = "hidden"
      return () => {
        document.body.style.overflow = "auto"
      }
    }, [])

    if (!storiesData) {
      return null;
    }

    const stories = storiesData.story.map(story => {
      return {
        url: story.url,
        duration: 3000,
        type: story?.type?.toUpperCase() === "IMG" ? "image" : story.type,
        header: {
          heading: storiesData.user.name,
          subheading: storiesData.story_label,
          profileImage: story.thumb,
        },
        seeMore: () => null,
        seeMoreCollapsed: () => <S.BottomCaption style={customStyle}>{story.caption}</S.BottomCaption>
      }
    })

    return openStories ? (
      <S.Overlay>
        <S.ModalContainer>
          <S.IconWrapper>
            <S.Icon>
              <CrossIcon onClick={() => {
                setOpenStories(false)
                onClose()
              }} />
            </S.Icon>
          </S.IconWrapper>
          <S.StoriesWrapper>
            <Stories stories={stories}
              defaultInterval={8000}
              width={360}
              height={646}
              header={Header}
              keyboardNavigation
            />
          </S.StoriesWrapper>
        </S.ModalContainer>
      </S.Overlay>
    ) : null
}
